module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.4e85bc9e.ttf";